import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const ProjectPlanPenIcon = createIcon({
  displayName: 'ProjectPlanPenIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path d="M0,0H24V24H0Z" fill="none" />
      <line
        x1="10"
        y1="8"
        x2="7"
        y2="8"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M3,18.5V5.5A2.5,2.5,0,0,1,5.5,3H6A1,1,0,0,1,7,4V15a1,1,0,0,1-1,1H5.5A2.5,2.5,0,0,0,3,18.5H3A2.5,2.5,0,0,0,5.5,21H19a2,2,0,0,0,2-2V11"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M14.74954,12.68358l-2.17872.31126a.49748.49748,0,0,1-.56625-.56154c.08915-.624.2226-1.558.312-2.18341a1.99992,1.99992,0,0,1,.56562-1.13112l5.49737-5.49761a2.12038,2.12038,0,0,1,2.9988,0h0a2.12065,2.12065,0,0,1,0,2.99893L15.88084,12.1179A1.99973,1.99973,0,0,1,14.74954,12.68358Z"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </>
  ),
})

const ProjectPlanPen: FC<IconProps> = (props) => {
  return <CustomIcon as={ProjectPlanPenIcon} {...props} />
}

export default memo(ProjectPlanPen)
